import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { projectInvoiceStatusConfig } from 'entities';
import { ActiveProjectInvoiceDiscountRequest, EnrichedProjectInvoice } from '../types';
import { sortByProperty } from 'utils/array';

export const projectInvoiceLoaders = getLoaders({
  projectInvoiceCounts: {
    load: async (): Promise<Record<string, number>> => {
      return executeApiCall({
        path: '/invoice/projects/invoices/counts',

        method: 'get',
      });
    },
  },

  projectInvoicesReadyToInvoice: {
    load: async (): Promise<EnrichedProjectInvoice[]> => {
      return executeApiCall({
        path: '/invoice/projects/invoices',

        method: 'get',

        payload: {
          status: projectInvoiceStatusConfig.readyToInvoice.code,
        },
      });
    },

    defaultParser: (invoices: EnrichedProjectInvoice[]) =>
      sortByProperty(invoices, ['clientName', 'currency', 'value'], {
        value: (a, b) => Number(b) - Number(a),
      }),
  },

  activeProjectInvoiceDiscountRequests: {
    load: async (): Promise<ActiveProjectInvoiceDiscountRequest[]> => {
      return executeApiCall({
        path: '/invoice/projects/invoices/discount-requests',

        method: 'get',
      });
    },
  },
});
